import styled from "styled-components";

/* ── Row-level styled components (KPI-specific) ── */

export const CheckboxCell = styled.div.attrs({ className: "kpi-no-expand" })`
  width: 46px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
`;

export const RowNumberCell = styled.div`
  width: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 18px;
  font-size: 12px;
  font-weight: 700;
  color: var(--ink-4);
  font-family: var(--font-mono);
`;

export const KpiNameCell = styled.div`
  flex: 1;
  min-width: 350px;
  padding: 14px 14px 14px 10px;
`;

export const KpiNameText = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: ${({ $isDerived }) => ($isDerived ? "#2563eb" : "var(--ink)")};
  line-height: 1.5;
  font-family: var(--font-sans);
  letter-spacing: -0.01em;
  word-break: break-word;
`;

/* ── Accordion panel wrapper (KPI-specific styling) ── */

export const PanelContent = styled.div`
  padding: 16px 20px 20px;
  background: linear-gradient(to bottom, #f8faff, #f4f6fe);
  border-top: 2px solid var(--accent-2);
  position: sticky;
  left: 0;
  width: var(--kpi-view-width, 100%);
  box-sizing: border-box;
`;

/* ── Overview layout helpers ── */

export const OverviewColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
`;

export const YoYSection = styled.div`
  padding: 12px 14px;
  background: var(--surface-2);
  border-radius: 10px;
  border: 1px solid var(--rule);
`;

export const YoYTitle = styled.div`
  font-size: 10px;
  font-weight: 700;
  color: var(--ink-3);
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 10px;
  font-family: var(--font-sans);
`;

export const YoYRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const YoYItem = styled.div``;

export const YoYItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const YoYLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
`;

export const YoYValue = styled.span`
  font-size: 11px;
  font-weight: 700;
  font-family: var(--font-mono);
  color: ${({ $color }) => $color};
`;

export const YoYDelta = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const YoYDeltaLabel = styled.span`
  font-size: 10.5px;
  color: var(--ink-3);
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding-top: 14px;
  border-top: 1px solid var(--rule-2);
`;
